"use client";

import { cn } from "@/lib/utils";
import { motion } from "framer-motion";

export function MovingBorder({
  children,
  duration = 3000,
  className,
  containerClassName,
  borderClassName,
  as: Component = "div",
}: {
  children: React.ReactNode;
  duration?: number;
  className?: string;
  containerClassName?: string;
  borderClassName?: string;
  as?: React.ElementType;
}) {
  return (
    <Component
      className={cn("relative overflow-hidden rounded-2xl p-[2px]", containerClassName)}
    >
      <div
        className={cn(
          "absolute inset-0",
          borderClassName
        )}
        style={{
          background:
            "conic-gradient(from var(--angle, 0deg), transparent 60%, #6366f1, #8b5cf6, #a855f7, transparent 40%)",
          animation: `rotate-border ${duration}ms linear infinite`,
        }}
      />
      <div
        className={cn(
          "relative z-10 rounded-[calc(1rem-2px)] bg-card",
          className
        )}
      >
        {children}
      </div>
      <style jsx>{`
        @property --angle {
          syntax: '<angle>';
          initial-value: 0deg;
          inherits: false;
        }
        @keyframes rotate-border {
          to {
            --angle: 360deg;
          }
        }
      `}</style>
    </Component>
  );
}
